import { pageAfterLogin } from "@/utils/user_authorization"

export default function({ store, redirect }) {
  if (store.state.auth.loggedIn) {
    return redirect(pageAfterLogin(store.state.auth.user.roles))
  }
}
